import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "6rem", fontWeight: "bold", mb: 2 }}>
        404
      </Typography>
      <Typography variant="h4" sx={{ mb: 3 }}>
        ¡Oops! Página no encontrada
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Parece que la página que buscas no existe. Puedes volver al inicio para continuar navegando.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        sx={{ padding: "10px 20px", fontSize: "16px", textTransform: "none" }}
      >
        Volver al inicio
      </Button>
    </Box>
  );
};

export default NotFoundPage;
